
import React from "react";

function HideText(){

    return(
        
        <h1 className="hide_txt">For the best experience, please view on a laptop</h1>
    )

}

export default HideText;